import { ref, shallowRef } from 'vue'
import { RestApiClient } from 'ifield-core-components'
import { toLocalTz, toLocalTzAttribute } from '@/js/TimezoneHelper'

/**
 * ユーザーリスト表示用データの利用
 */
export const useUserListData = () => {
  /**
   * 取得したユーザーデータ
   * @type {ShallowRef.<Object[]>}
   */
  const data = shallowRef([])
  /**
   * 取得日時
   * @type {Ref.<Date>}
   */
  const updateDate = ref(null)

  /**
   * データを取得する
   */
  const fetchData = async () => {
    const url = RestApiClient.createApiUrl('user/list_view')
    const json = await RestApiClient.executeGetApi(url)
    data.value = json.data.map((d) => ({
      ...d,
      last_login_at: toLocalTz(d.last_login_at),
      current_status_update_at: toLocalTz(d.current_status_update_at),
      checkin_at: toLocalTz(d.checkin_at),
      checkout_at: toLocalTz(d.checkout_at),
      activity_change_at: toLocalTz(d.activity_change_at),
      last_positioning_at: toLocalTz(d.last_positioning_at),
      create_at: toLocalTz(d.create_at),
      update_at: toLocalTz(d.update_at),
      attributes: d.attributes.map((attr) => toLocalTzAttribute(attr)),
    }))
    updateDate.value = new Date()
  }

  return {
    data,
    updateDate,
    fetchData,
  }
}
